import React, {useContext, useEffect} from 'react';
import PropTypes from 'prop-types';

import SelectedItemPackingDrawer from "../SelectedItemPackingDrawer";
import WmsItemInformationPacking from "../WmsItemInformationPacking";

import {BarCodeScannerContext} from "../../../../../../../../contexts/barCodeScannerContext";

import {packingStepNames} from "../../../packingSteps";

ShipmentMonoPacking.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    beginPacking:PropTypes.func.isRequired,
    beginShipmentWeigh: PropTypes.func.isRequired,
    packingStep: PropTypes.object.isRequired,
};

function ShipmentMonoPacking({open, handleClose, beginPacking, beginShipmentWeigh, packingStep}) {
    const {scannedString, resetScannedString} = useContext(BarCodeScannerContext)

    const lineItem = packingStep.selectedShipment.lineItems[0]

    useEffect(() => {
        if (packingStep.stepName === packingStepNames.PEEK && scannedString === lineItem.eanCode) {
            resetScannedString()
            beginPacking()
        }
    }, [scannedString]);

    return (
        <SelectedItemPackingDrawer
            open={open}
            handleClose={handleClose}
            packingStep={packingStep}
        >
            <WmsItemInformationPacking
                lineItem={lineItem}
                packingStep={packingStep}
                beginPacking={beginPacking}
                beginShipmentWeigh={beginShipmentWeigh}
            />
        </SelectedItemPackingDrawer>
    );
}

export default ShipmentMonoPacking;
